export default __webpack_public_path__ + "static/media/10_otravena-trojnozka_smidovaLCR_upr-min.79e40ec5.jpg";